import { createSelector } from 'reselect';
import { State } from './types';

function getTranslations(state: State) {
	return state.translations;
}

export const selectTranslations = createSelector([getTranslations], translations => translations);
